module.exports = __webpack_public_path__ + "img/banner_02.a44652f5.png";